"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerSelectorEnum = void 0;
let DatePickerSelectorEnum = exports.DatePickerSelectorEnum = /*#__PURE__*/function (DatePickerSelectorEnum) {
  DatePickerSelectorEnum["DATE"] = "DATE";
  DatePickerSelectorEnum["MONTH"] = "MONTH";
  DatePickerSelectorEnum["YEAR"] = "YEAR";
  return DatePickerSelectorEnum;
}({});